// extracted by mini-css-extract-plugin
export default {"root":"InputWithCopy_root__wRSAE","copy":"InputWithCopy_copy__uARmJ"};